module.exports = "<page-layout header-config=\"vm.headerConfig\" wide-view=\"true\" hide-footer=\"true\">\n\n    <h2 class=\"subtitle\">Please select a region to launch:</h2>\n\n    <region-selection\n            selected=\"vm.region\"\n            regions=\"vm.listOfRegions\"\n            columns=\"3\"\n            on-select=\"vm.selectRegion(region)\">\n    </region-selection>\n\n</page-layout>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/regionSelectionLanding/regionSelectionLanding.html
 ** module id = 71
 ** module chunks = 0
 **/